// extracted by mini-css-extract-plugin
export default {"container":"StartApplicationDisclaimer_container__FC7Hp","content":"StartApplicationDisclaimer_content__5LLZD","appTitle":"StartApplicationDisclaimer_appTitle__dDpx6"};